"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

jQuery(document).ready(function ($) {
  var heroAnimations = jQuery('.module-hero_home__animation');
  heroAnimations.each(function () {
    if ($(this).length > 0) {
      if ((typeof bodymovin === "undefined" ? "undefined" : _typeof(bodymovin)) !== undefined && typeof bodymovin !== 'undefined') {
        var file_path = $(this).data('animation-json');
        var hero_home_animation = bodymovin.loadAnimation({
          container: $(this).get(0),
          // node
          path: file_path,
          renderer: 'svg',
          loop: true,
          autoplay: false
        });
        $(this).addClass('active');
        hero_home_animation.playSegments([0, 450], true);
      }
    }
  });

  if ($('.module-hero__animation').length > 0) {
    if ((typeof bodymovin === "undefined" ? "undefined" : _typeof(bodymovin)) !== undefined && typeof bodymovin !== 'undefined') {
      var file_path = $('.module-hero__animation').data('animation-json');
      var hero_animation = bodymovin.loadAnimation({
        container: document.getElementById('module-hero__animation'),
        path: file_path,
        renderer: 'svg',
        loop: true,
        autoplay: false
      });
      $('.module-hero__animation').addClass('active');
      hero_animation.playSegments([0, 450], true);
    }
  }

  if ($('.about-ochresoft__animation').length > 0) {
    document.addEventListener('scroll', function () {
      if ($('.about-ochresoft').isOnScreen()) {
        if ((typeof bodymovin === "undefined" ? "undefined" : _typeof(bodymovin)) !== undefined && typeof bodymovin !== 'undefined') {
          var file_path = $('.about-ochresoft__animation').data('animation-json');
          var about_animation = bodymovin.loadAnimation({
            container: document.getElementById('about-ochresoft__animation'),
            path: file_path,
            renderer: 'svg',
            loop: true,
            autoplay: false
          });
          $('.module-hero__animation').addClass('active');
          about_animation.playSegments([0, 450], true);
        }
      }
    });
  }

  var waitForEl = function waitForEl(selector, callback) {
    if ($(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 100);
    }
  };

  waitForEl('.hs_submit', function (e) {
    $('.hs_submit').on('click', function () {
      // 	const formid = $(this).closest('form');
      // 	formid.submit();
      console.log('2345');
    });
    $('.hs-button').append("<svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25'><script xmlns='' id='dashlane_webauthn' name='forward_webauthn_ready'/><g id='Group_8' data-name='Group 8' transform='translate(-1243 -3060)'><g id='Group_20040' data-name='Group 20040'><circle id='Ellipse_12' data-name='Ellipse 12' cx='12.5' cy='12.5' r='12.5' transform='translate(1243 3060)' fill='#ff7820'/><path id='Path_12' data-name='Path 12' d='M2972.132,3072.792l6.266,6.266-6.266,6.266' transform='translate(-1718.766 -6.396)' fill='none' stroke='#fff' stroke-width='2'/></g></g></svg>");
  }); // SET COOKIE TIME

  function setCookie() {
    document.cookie = "Help=true; expires=Sat, 30 Dec 2019 23:59:59 UTC";
  } // CREATE COOKIE


  $('#help').on('hidden.bs.modal', function (event) {
    //console.log('Modal closed!');
    setCookie();
    $('#help').modal('hide');
  }); // DATEPICKER
  // $(function (event) {
  // 	// $('#datetimepicker1').datetimepicker();
  // 	$("#datetimepicker1").datetimepicker({ format: 'D-MM-Y' }); // ADD TIME HH:mm
  // });
  // $('#datetimepicker1').on('focus', 'input', function () {
  // 	$(this).attr('autocomplete', 'off');
  // });
  // IS ON SCREEN - TIMELINE ANIMATION

  if ($('.page-template-template-training').length) {
    $(".module--timeline").find(".container").each(function () {
      $(this).addClass("animated");
    });
  } else {
    $(window).scroll(function () {
      $(".module--timeline").find(".container").each(function () {
        if ($(this).isOnScreen()) {
          $(this).addClass("animated");
        }
      });
    });
  } // IS ON SCREEN - CIRCLE LINE ANIMATION


  if ($('.introduction .circle-line').length) {
    $(window).scroll(function () {
      if ($('.introduction .circle-line').isOnScreen()) {
        $('.introduction .circle-line').addClass("animated");
      }
    });
  } // SLICK


  $(".herobanner-slider").slick({
    dots: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    infinite: true
  });
  $('.up-next').on('click', function () {
    $('.herobanner-slider').slick('slickNext');
  });
  $(".explore-services-slider").on('init', function (event, slick) {
    var pager = document.querySelectorAll('.explore-pager a[data-slide]');

    var pagerArray = _toConsumableArray(pager);

    pagerArray.forEach(function (item) {
      $(item).hover(function () {
        // change slide on hover in
        $(".explore-services-slider").slick('slickGoTo', item.dataset.slide);
      }, function () {// do nothing on hover out
      });
    });
  });
  $(".explore-services-slider").slick({
    dots: false,
    speed: 500,
    fade: true,
    // appendDots: $(".explore-pager__item"),
    autoplay: false,
    autoplaySpeed: 6000,
    arrows: false
  });
  $(".case-study__slider").slick({
    dots: false,
    speed: 500,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true,
    infinite: true,
    prevArrow: "<img class='prev-button' src='" + themePath.theme_directory + "/assets/images/arrow-orange.svg' />",
    nextArrow: "<img class='next-button'  src='" + themePath.theme_directory + "/assets/images/arrow-orange.svg' />"
  });
  $('.explore-pager__item').first().addClass('active2');
  $('.explore-services-slider').on('afterChange', function (slick, currentSlide) {
    $('a[data-slide]').removeClass('active2');
    var i = $('.explore-services-slider .slick-current').attr("data-slick-index"); // console.log(i);

    var pager = document.querySelectorAll('.explore-pager a[data-slide]');

    var pagerArray = _toConsumableArray(pager);

    pagerArray.forEach(function (item) {
      if (item.dataset.slide === i) {
        $(item).addClass('active2');
      }
    });
  });
  $('.explore-pager a[data-slide]').click(function (e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $('.explore-services-slider').slick('slickGoTo', slideno);
  });
  $(".our-promise").slick({
    dots: false,
    speed: 500,
    fade: true,
    appendDots: $(".pager-item"),
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false
  });
  $('.our-promise__pager .pager-item').first().addClass('active');
  $('.our-promise').on('afterChange', function (slick, currentSlide) {
    var i = $('.our-promise .slick-current').attr("data-slick-index");
    $('a[data-slide]').removeClass('active');
    var pager = document.querySelectorAll('.our-promise__pager a[data-slide]');

    var pagerArray = _toConsumableArray(pager);

    pagerArray.forEach(function (item) {
      if (item.dataset.slide == i) {
        $(item).addClass('active');
      }
    });
  });
  $('.our-promise__pager a[data-slide]').click(function (e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $('.our-promise').slick('slickGoTo', slideno);
    console.log(slideno);
  }); // SLICK ARROWS

  $(".slider__left").on("click", function () {
    $('.slider').slick("slickPrev");
  });
  $('.slider__right').on("click", function () {
    $('.slider').slick("slickNext");
  }); //POINTS ANIMATION

  $('.point__title').first().addClass('active');
  var elem = $('.point__title');
  var i = 0;

  function points() {
    $(elem).each(function (index) {
      if (i == index) {
        $(this).addClass('active');
      } else if (i == $(elem).length) {
        $(this).addClass('active');
        i = 0;
      } else {
        $(this).removeClass('active');
      }
    });
    i++;
  }

  points();
  window.setInterval(points, 4000); // AJAX MODAL

  var $button = $('.btn.btn--slider');
  $button.click(function () {
    // Get the ID of the parent
    var id = $(this).data('id'); // Get the ID of the content

    var count = $(this).data('count'); // Get the Type

    var type = $(this).data('type'); // Get the class of the modal

    var modalTarget = $('.modal.modal--embed').find('.modal-content'); // Add a loading element

    $(modalTarget).html('<div class="modal-loading">Loading...</div>'); // Add class to modal

    $('.modal.modal--embed').modal('show'); // AJAX call the ID and Type

    $.ajax({
      url: ajaxurl,
      data: {
        'action': 'fetch_modal_content',
        'id': id,
        'count': count,
        'type': type
      },
      // Output the modal
      success: function success(data) {
        $(modalTarget).html(data);
      }
    });
  }); // REPLACE ALL SVG IMAGES WITH INLINE SVG

  $('img.svg').each(function () {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');
    $.get(imgURL, function (data) {
      //Get the SVG tag, ignore the rest
      var $svg = $(data).find('svg'); //Add replaced image's ID to the new SVG

      if (typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      } //Add replaced image's classes to the new SVG


      if (typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass + ' replaced-svg');
      } //Remove any invalid XML tags as per http:validator.w3.org


      $svg = $svg.removeAttr('xmlns:a'); // Replace image with new SVG

      $img.replaceWith($svg);
    });
  });
  $("svg").each(function (idx, el) {
    $(el).get(0).setAttribute("preserveAspectRatio", "xMinYMin");
  }); // BOOTSTRAP MENU

  $(".menu-dropdown-toggle").on("click", function () {
    $(this).toggleClass("open");
    $(this).siblings("ul").toggleClass("open");
  });
  $("button.navbar-toggler").on("click", function (event) {
    $(".site-header").toggleClass("open"); // $('#mobile-navigation').toggleClass('show');

    if ($('#mobile-navigation').hasClass('show')) {
      $(this).removeClass('show');
    } else {
      $(this).addClass('show');
    }

    $("html").toggleClass("open");
  });
  $('#menu-mobile-navigation .menu-item--level-0>a').each(function () {
    $(this).append('<svg class="menu-arrow" xmlns="http://www.w3.org/2000/svg" width="8.388" height="13.947" viewBox="0 0 8.388 13.947"><path id="Path_54232" data-name="Path 54232" d="M2972.132,3072.792l6.266,6.266-6.266,6.266" transform="translate(-2971.425 -3072.085)" fill="none" stroke="#fff" stroke-width="2"/></svg>');
  });
  $('#menu-mobile-navigation .menu-item--level-0>a').click(function () {
    setTimeout(function () {
      $('#menu-mobile-navigation .menu-item--level-0').each(function () {
        if ($(this).children('.dropdown-menu').eq(0).hasClass('show')) {
          $(this).addClass('showing');
        } else {
          $(this).removeClass('showing');
        }
      });
    }, 10);
  }); // $('#primary-navigation .menu-item-has-children>a').each(function () {
  // 	$(this).append('<svg class="menu-arrow" xmlns="http://www.w3.org/2000/svg" width="8.388" height="13.947" viewBox="0 0 8.388 13.947"><path id="Path_54232" data-name="Path 54232" d="M2972.132,3072.792l6.266,6.266-6.266,6.266" transform="translate(-2971.425 -3072.085)" fill="none" stroke="#fff" stroke-width="2"/></svg>')
  // });

  $('#primary-navigation .menu-item-has-children >a').click(function () {
    setTimeout(function () {
      $('#primary-navigation .menu-item-has-children ').each(function () {
        if ($(this).children('.dropdown-menu').eq(0).hasClass('show')) {
          $(this).addClass('showing');
        } else {
          $(this).removeClass('showing');
        }
      });
    }, 10);
  });
  $('#mobile-navigation form').append('<button class="search-button--mobile"></button>');
  $('.herobanner form').append('<button class="search-button--mobile"></button>'); //SEARCH FORM

  $("#searchFormToggle").on("click", function () {
    $(this).toggleClass("search-active");
    $(".search-form-dropdown").toggleClass("search-visible");
  });
  $(document).on('focus', 'input', function () {
    $(this).parent().parent().addClass('active');
  });
  $(document).on('focus', 'textarea', function () {
    $(this).parent().parent().addClass('active');
  });
  $(document).on("change keyup", 'input', function () {
    $(this).parent().parent().addClass('active');
  });
  $(document).on("change keyup", 'textarea', function () {
    $(this).parent().parent().addClass('active');
  });
  $(document).on('blur', 'input', function () {
    if ($(this).val().length === 0) {
      $(this).parent().parent().removeClass('active');
    }
  });
  $(document).on('blur', 'textarea', function () {
    if ($(this).val().length === 0) {
      $(this).parent().parent().removeClass('active');
    }
  }); // BOOTSTRAP MENU FIX

  (function ($, sr) {
    var debounce = function debounce(func, threshold, execAsap) {
      var timeout;
      return function debounced() {
        var obj = this,
            args = arguments;

        function delayed() {
          if (!execAsap) func.apply(obj, args);
          timeout = null;
        }

        ;
        if (timeout) clearTimeout(timeout);else if (execAsap) func.apply(obj, args);
        timeout = setTimeout(delayed, threshold || 100);
      };
    };

    jQuery.fn[sr] = function (fn) {
      return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
    };
  })(jQuery, 'smartresize');

  $(window).smartresize(function () {
    var $resizeHeight = $(".mega-dropdown-toggle.active").siblings(".dropdown-menu.show").height(); //console.log($resizeHeight);

    var $resizeHeightCalc = $resizeHeight + 80 + "px";
    $(".nav-megamenu > .dropdown-menu").css('min-height', $resizeHeightCalc);
  });
  $(window).resize(function () {
    $(".mega-dropdown-toggle.active").siblings(".dropdown-menu.show").toggleClass("in-process");
  });
  $(".nav-megamenu__menu .menu-item-has-children .mega-dropdown-toggle").on("click", function () {
    var $height = $(this).siblings(".dropdown-menu").height(); //console.log($height);

    var $heightCalc = $height + 80 + "px";
    $(".nav-megamenu > .dropdown-menu").css('min-height', $heightCalc);
    $(".mega-dropdown-toggle").not(this).removeClass("active");
    $(this).toggleClass("active");
  });
  $(".dropdown-menu").on("click", function (event) {
    event.stopPropagation();
  });
  $('html').click(function () {
    $(".mega-dropdown-toggle").removeClass("active");
  });
  $('[data-toggle=dropdown]').on('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(this).parent().siblings().children().removeClass('show');
    $(this).siblings().toggleClass('show');
  });
  $(document).on('click', function (event) {
    $('.navbar--primary .dropdown-menu').removeClass('show');
  }); // TARGET IE - CSS html[data-useragent*='rv:11.0'] {}

  var doc = document.documentElement;
  doc.setAttribute('data-useragent', navigator.userAgent); // OPTIONAL ALERT

  $('.alert__dropdown__toggle').click(function () {
    $(this).parents('.alert').toggleClass('active');
    $('.alert__dropdown__toggle').toggleClass('active');
    $('.alert__dropdown__reveal').slideToggle();
  });

  function subProdHeight() {
    var maxHeight = -1;
    $('.sub-products').each(function () {
      maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });
    $('.sub-products').each(function () {
      $(this).height(maxHeight + 45);
    });
  }

  subProdHeight();
  $('.integration-process__list li').each(function () {
    var me = $(this);
    me.html(me.text().replace(/(^\w+)/, '<strong>$1</strong>'));
  }); // Handle clicking on team cards

  $('.module-team__grid').on('click', '.module-team__card--content', function () {
    // console.log('fire');
    var card = jQuery(this);
    console.log(card);

    if (!card.hasClass('module-team__card--animating')) {
      if (card.hasClass('module-team__card--open')) {
        team_dropdown_close(card);
      } else {
        if ($('.module-team__card--open').length > 0) {
          $('.module-team__card--open').each(function () {
            team_dropdown_close(jQuery(this));
          });
          setTimeout(function () {
            team_dropdown_open(card);
          }, 600, card);
        } else {
          team_dropdown_open(card);
        }
      }
    }
  });

  if (window.location.hash.substring(1).length > 0) {
    var anchor = window.location.hash.substring(1);
    var card = $('#' + anchor);

    if (!card.hasClass('module-team__card--animating')) {
      if (card.hasClass('module-team__card--open')) {
        team_dropdown_close(card);
      } else {
        if ($('.module-team__card--open').length > 0) {
          $('.module-team__card--open').each(function () {
            team_dropdown_close(jQuery(this));
          });
          setTimeout(function () {
            team_dropdown_open(card);
          }, 600, card);
        } else {
          team_dropdown_open(card);
        }
      }
    }
  } // Handle dropdown 


  function team_dropdown_open(card) {
    card.addClass('module-team__card--animating');
    jQuery(window).trigger('resize');
    var card_height = card.innerHeight();
    var team_offset = card.closest('.module-team__grid').offset().top;
    var card_offset = card.offset().top;
    var card_offset_relative = card.offset().top - team_offset;
    var $dropdown = $('#' + card.data('team_id'));
    var dropdown_height = $dropdown.find('.module-team__dropdown-content').innerHeight();
    $dropdown.css('height', '0');
    $dropdown.css('top', card_height + card_offset_relative + 'px');
    card.removeClass('module-team__card--closed');
    card.addClass('module-team__card--open');
    setTimeout(function () {
      card.css('margin-bottom', dropdown_height + 'px');
      $dropdown.css('height', dropdown_height + 'px');
      $("html, body").animate({// scrollTop: ((card_height + card_offset - 150) + 'px')
      }, 600);
    }, 100, card, $dropdown, card_height, team_offset);
    setTimeout(function () {
      card.removeClass('module-team__card--animating');
      $dropdown.addClass('module-team__dropdown--open');
    }, 700, card);
  }

  function team_dropdown_close(card) {
    card.addClass('module-team__card--animating');
    jQuery(window).trigger('resize');
    card.css('margin-bottom', '');
    var $dropdown = $('#' + card.data('team_id'));
    $dropdown.css('height', 0);
    card.addClass('module-team__card--closed');
    card.removeClass('module-team__card--open');
    setTimeout(function () {
      $dropdown.css('top', '');
      card.removeClass('module-team__card--animating');
      $dropdown.removeClass('module-team__dropdown--open');
    }, 600, card, $dropdown);
    jQuery(window).trigger('resize');
  }

  jQuery(window).on('resize', function () {
    jQuery('.module-team-card--open').each(function () {
      adjust_open_team_dropdown_height(jQuery(this));
    });
  });

  function adjust_open_team_dropdown_height(card) {
    var card_height = card.innerHeight();
    var team_offset = card.closest('.module-team__grid').offset().top;
    var card_offset = card.offset().top;
    var card_offset_relative = card.offset().top - team_offset;
    var $dropdown = $('#' + card.data('team_id'));
    var dropdown_height = $dropdown.find('.module-team__dropdown-content').innerHeight();
    $dropdown.css('top', card_height + card_offset_relative + 'px');
    card.css('margin-bottom', dropdown_height + 'px');
    $dropdown.css('height', dropdown_height + 'px');
  }

  $(function () {
    $('.lazy').lazy();
  }); // IN SITU VIDEO PLAY / COVER

  $('.in-situ-video__btn').click(function () {
    var button = $(this);
    console.log('hey');
    var video = button.attr('data-video-code');
    button.parents('.in-situ-video').html(video);

    if ($('.in-situ-video iframe[src^="https://www.youtube.com"]')) {
      $('.in-situ-video iframe')[0].src += "?feature=oembed&autoplay=1";
    }

    ;
  });
}); // OBJECTFIT JS

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-objectfit-setclasses !*/

!function (e, n, t) {
  function r(e, n) {
    return _typeof(e) === n;
  }

  function o() {
    var e, n, t, o, i, s, a;

    for (var l in C) {
      if (C.hasOwnProperty(l)) {
        if (e = [], n = C[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t < n.options.aliases.length; t++) {
          e.push(n.options.aliases[t].toLowerCase());
        }

        for (o = r(n.fn, "function") ? n.fn() : n.fn, i = 0; i < e.length; i++) {
          s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), h.push((o ? "" : "no-") + a.join("-"));
        }
      }
    }
  }

  function i(e) {
    var n = _.className,
        t = Modernizr._config.classPrefix || "";

    if (w && (n = n.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
      n = n.replace(r, "$1" + t + "js$2");
    }

    Modernizr._config.enableClasses && (n += " " + t + e.join(" " + t), w ? _.className.baseVal = n : _.className = n);
  }

  function s(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, n, t) {
      return n + t.toUpperCase();
    }).replace(/^-/, "");
  }

  function a(e, n) {
    return !!~("" + e).indexOf(n);
  }

  function l() {
    return "function" != typeof n.createElement ? n.createElement(arguments[0]) : w ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
  }

  function f(e, n) {
    return function () {
      return e.apply(n, arguments);
    };
  }

  function u(e, n, t) {
    var o;

    for (var i in e) {
      if (e[i] in n) return t === !1 ? e[i] : (o = n[e[i]], r(o, "function") ? f(o, t || n) : o);
    }

    return !1;
  }

  function p(n, t, r) {
    var o;

    if ("getComputedStyle" in e) {
      o = getComputedStyle.call(e, n, t);
      var i = e.console;
      if (null !== o) r && (o = o.getPropertyValue(r));else if (i) {
        var s = i.error ? "error" : "log";
        i[s].call(i, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
      }
    } else o = !t && n.currentStyle && n.currentStyle[r];

    return o;
  }

  function c(e) {
    return e.replace(/([A-Z])/g, function (e, n) {
      return "-" + n.toLowerCase();
    }).replace(/^ms-/, "-ms-");
  }

  function d() {
    var e = n.body;
    return e || (e = l(w ? "svg" : "body"), e.fake = !0), e;
  }

  function m(e, t, r, o) {
    var i,
        s,
        a,
        f,
        u = "modernizr",
        p = l("div"),
        c = d();
    if (parseInt(r, 10)) for (; r--;) {
      a = l("div"), a.id = o ? o[r] : u + (r + 1), p.appendChild(a);
    }
    return i = l("style"), i.type = "text/css", i.id = "s" + u, (c.fake ? c : p).appendChild(i), c.appendChild(p), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), p.id = u, c.fake && (c.style.background = "", c.style.overflow = "hidden", f = _.style.overflow, _.style.overflow = "hidden", _.appendChild(c)), s = t(p, e), c.fake ? (c.parentNode.removeChild(c), _.style.overflow = f, _.offsetHeight) : p.parentNode.removeChild(p), !!s;
  }

  function v(n, r) {
    var o = n.length;

    if ("CSS" in e && "supports" in e.CSS) {
      for (; o--;) {
        if (e.CSS.supports(c(n[o]), r)) return !0;
      }

      return !1;
    }

    if ("CSSSupportsRule" in e) {
      for (var i = []; o--;) {
        i.push("(" + c(n[o]) + ":" + r + ")");
      }

      return i = i.join(" or "), m("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == p(e, null, "position");
      });
    }

    return t;
  }

  function y(e, n, o, i) {
    function f() {
      p && (delete P.style, delete P.modElem);
    }

    if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
      var u = v(e, o);
      if (!r(u, "undefined")) return u;
    }

    for (var p, c, d, m, y, g = ["modernizr", "tspan", "samp"]; !P.style && g.length;) {
      p = !0, P.modElem = l(g.shift()), P.style = P.modElem.style;
    }

    for (d = e.length, c = 0; d > c; c++) {
      if (m = e[c], y = P.style[m], a(m, "-") && (m = s(m)), P.style[m] !== t) {
        if (i || r(o, "undefined")) return f(), "pfx" == n ? m : !0;

        try {
          P.style[m] = o;
        } catch (h) {}

        if (P.style[m] != y) return f(), "pfx" == n ? m : !0;
      }
    }

    return f(), !1;
  }

  function g(e, n, t, o, i) {
    var s = e.charAt(0).toUpperCase() + e.slice(1),
        a = (e + " " + b.join(s + " ") + s).split(" ");
    return r(n, "string") || r(n, "undefined") ? y(a, n, o, i) : (a = (e + " " + j.join(s + " ") + s).split(" "), u(a, n, t));
  }

  var h = [],
      C = [],
      S = {
    _version: "3.6.0",
    _config: {
      classPrefix: "",
      enableClasses: !0,
      enableJSClass: !0,
      usePrefixes: !0
    },
    _q: [],
    on: function on(e, n) {
      var t = this;
      setTimeout(function () {
        n(t[e]);
      }, 0);
    },
    addTest: function addTest(e, n, t) {
      C.push({
        name: e,
        fn: n,
        options: t
      });
    },
    addAsyncTest: function addAsyncTest(e) {
      C.push({
        name: null,
        fn: e
      });
    }
  },
      Modernizr = function Modernizr() {};

  Modernizr.prototype = S, Modernizr = new Modernizr();

  var _ = n.documentElement,
      w = "svg" === _.nodeName.toLowerCase(),
      x = "Moz O ms Webkit",
      b = S._config.usePrefixes ? x.split(" ") : [];

  S._cssomPrefixes = b;

  var E = function E(n) {
    var r,
        o = prefixes.length,
        i = e.CSSRule;
    if ("undefined" == typeof i) return t;
    if (!n) return !1;
    if (n = n.replace(/^@/, ""), r = n.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + n;

    for (var s = 0; o > s; s++) {
      var a = prefixes[s],
          l = a.toUpperCase() + "_" + r;
      if (l in i) return "@-" + a.toLowerCase() + "-" + n;
    }

    return !1;
  };

  S.atRule = E;
  var j = S._config.usePrefixes ? x.toLowerCase().split(" ") : [];
  S._domPrefixes = j;
  var z = {
    elem: l("modernizr")
  };

  Modernizr._q.push(function () {
    delete z.elem;
  });

  var P = {
    style: z.elem.style
  };
  Modernizr._q.unshift(function () {
    delete P.style;
  }), S.testAllProps = g;

  var N = S.prefixed = function (e, n, t) {
    return 0 === e.indexOf("@") ? E(e) : (-1 != e.indexOf("-") && (e = s(e)), n ? g(e, n, t) : g(e, "pfx"));
  };

  Modernizr.addTest("objectfit", !!N("objectFit"), {
    aliases: ["object-fit"]
  }), o(), i(h), delete S.addTest, delete S.addAsyncTest;

  for (var T = 0; T < Modernizr._q.length; T++) {
    Modernizr._q[T]();
  }

  e.Modernizr = Modernizr;
}(window, document);
/*! jQuery & Zepto Lazy v1.7.10 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */

!function (t, e) {
  "use strict";

  function r(r, a, i, u, l) {
    function f() {
      L = t.devicePixelRatio > 1, i = c(i), a.delay >= 0 && setTimeout(function () {
        s(!0);
      }, a.delay), (a.delay < 0 || a.combined) && (u.e = v(a.throttle, function (t) {
        "resize" === t.type && (w = B = -1), s(t.all);
      }), u.a = function (t) {
        t = c(t), i.push.apply(i, t);
      }, u.g = function () {
        return i = n(i).filter(function () {
          return !n(this).data(a.loadedName);
        });
      }, u.f = function (t) {
        for (var e = 0; e < t.length; e++) {
          var r = i.filter(function () {
            return this === t[e];
          });
          r.length && s(!1, r);
        }
      }, s(), n(a.appendScroll).on("scroll." + l + " resize." + l, u.e));
    }

    function c(t) {
      var i = a.defaultImage,
          o = a.placeholder,
          u = a.imageBase,
          l = a.srcsetAttribute,
          f = a.loaderAttribute,
          c = a._f || {};
      t = n(t).filter(function () {
        var t = n(this),
            r = m(this);
        return !t.data(a.handledName) && (t.attr(a.attribute) || t.attr(l) || t.attr(f) || c[r] !== e);
      }).data("plugin_" + a.name, r);

      for (var s = 0, d = t.length; s < d; s++) {
        var A = n(t[s]),
            g = m(t[s]),
            h = A.attr(a.imageBaseAttribute) || u;
        g === N && h && A.attr(l) && A.attr(l, b(A.attr(l), h)), c[g] === e || A.attr(f) || A.attr(f, c[g]), g === N && i && !A.attr(E) ? A.attr(E, i) : g === N || !o || A.css(O) && "none" !== A.css(O) || A.css(O, "url('" + o + "')");
      }

      return t;
    }

    function s(t, e) {
      if (!i.length) return void (a.autoDestroy && r.destroy());

      for (var o = e || i, u = !1, l = a.imageBase || "", f = a.srcsetAttribute, c = a.handledName, s = 0; s < o.length; s++) {
        if (t || e || A(o[s])) {
          var g = n(o[s]),
              h = m(o[s]),
              b = g.attr(a.attribute),
              v = g.attr(a.imageBaseAttribute) || l,
              p = g.attr(a.loaderAttribute);
          g.data(c) || a.visibleOnly && !g.is(":visible") || !((b || g.attr(f)) && (h === N && (v + b !== g.attr(E) || g.attr(f) !== g.attr(F)) || h !== N && v + b !== g.css(O)) || p) || (u = !0, g.data(c, !0), d(g, h, v, p));
        }
      }

      u && (i = n(i).filter(function () {
        return !n(this).data(c);
      }));
    }

    function d(t, e, r, i) {
      ++z;

      var _o = function o() {
        y("onError", t), p(), _o = n.noop;
      };

      y("beforeLoad", t);
      var u = a.attribute,
          l = a.srcsetAttribute,
          f = a.sizesAttribute,
          c = a.retinaAttribute,
          s = a.removeAttribute,
          d = a.loadedName,
          A = t.attr(c);

      if (i) {
        var _g = function g() {
          s && t.removeAttr(a.loaderAttribute), t.data(d, !0), y(T, t), setTimeout(p, 1), _g = n.noop;
        };

        t.off(I).one(I, _o).one(D, _g), y(i, t, function (e) {
          e ? (t.off(D), _g()) : (t.off(I), _o());
        }) || t.trigger(I);
      } else {
        var h = n(new Image());
        h.one(I, _o).one(D, function () {
          t.hide(), e === N ? t.attr(C, h.attr(C)).attr(F, h.attr(F)).attr(E, h.attr(E)) : t.css(O, "url('" + h.attr(E) + "')"), t[a.effect](a.effectTime), s && (t.removeAttr(u + " " + l + " " + c + " " + a.imageBaseAttribute), f !== C && t.removeAttr(f)), t.data(d, !0), y(T, t), h.remove(), p();
        });
        var m = (L && A ? A : t.attr(u)) || "";
        h.attr(C, t.attr(f)).attr(F, t.attr(l)).attr(E, m ? r + m : null), h.complete && h.trigger(D);
      }
    }

    function A(t) {
      var e = t.getBoundingClientRect(),
          r = a.scrollDirection,
          n = a.threshold,
          i = h() + n > e.top && -n < e.bottom,
          o = g() + n > e.left && -n < e.right;
      return "vertical" === r ? i : "horizontal" === r ? o : i && o;
    }

    function g() {
      return w >= 0 ? w : w = n(t).width();
    }

    function h() {
      return B >= 0 ? B : B = n(t).height();
    }

    function m(t) {
      return t.tagName.toLowerCase();
    }

    function b(t, e) {
      if (e) {
        var r = t.split(",");
        t = "";

        for (var a = 0, n = r.length; a < n; a++) {
          t += e + r[a].trim() + (a !== n - 1 ? "," : "");
        }
      }

      return t;
    }

    function v(t, e) {
      var n,
          i = 0;
      return function (o, u) {
        function l() {
          i = +new Date(), e.call(r, o);
        }

        var f = +new Date() - i;
        n && clearTimeout(n), f > t || !a.enableThrottle || u ? l() : n = setTimeout(l, t - f);
      };
    }

    function p() {
      --z, i.length || z || y("onFinishedAll");
    }

    function y(t, e, n) {
      return !!(t = a[t]) && (t.apply(r, [].slice.call(arguments, 1)), !0);
    }

    var z = 0,
        w = -1,
        B = -1,
        L = !1,
        T = "afterLoad",
        D = "load",
        I = "error",
        N = "img",
        E = "src",
        F = "srcset",
        C = "sizes",
        O = "background-image";
    "event" === a.bind || o ? f() : n(t).on(D + "." + l, f);
  }

  function a(a, o) {
    var u = this,
        l = n.extend({}, u.config, o),
        f = {},
        c = l.name + "-" + ++i;
    return u.config = function (t, r) {
      return r === e ? l[t] : (l[t] = r, u);
    }, u.addItems = function (t) {
      return f.a && f.a("string" === n.type(t) ? n(t) : t), u;
    }, u.getItems = function () {
      return f.g ? f.g() : {};
    }, u.update = function (t) {
      return f.e && f.e({}, !t), u;
    }, u.force = function (t) {
      return f.f && f.f("string" === n.type(t) ? n(t) : t), u;
    }, u.loadAll = function () {
      return f.e && f.e({
        all: !0
      }, !0), u;
    }, u.destroy = function () {
      return n(l.appendScroll).off("." + c, f.e), n(t).off("." + c), f = {}, e;
    }, r(u, l, a, f, c), l.chainable ? a : u;
  }

  var n = t.jQuery || t.Zepto,
      i = 0,
      o = !1;
  n.fn.Lazy = n.fn.lazy = function (t) {
    return new a(this, t);
  }, n.Lazy = n.lazy = function (t, r, i) {
    if (n.isFunction(r) && (i = r, r = []), n.isFunction(i)) {
      t = n.isArray(t) ? t : [t], r = n.isArray(r) ? r : [r];

      for (var o = a.prototype.config, u = o._f || (o._f = {}), l = 0, f = t.length; l < f; l++) {
        (o[t[l]] === e || n.isFunction(o[t[l]])) && (o[t[l]] = i);
      }

      for (var c = 0, s = r.length; c < s; c++) {
        u[r[c]] = t[0];
      }
    }
  }, a.prototype.config = {
    name: "lazy",
    chainable: !0,
    autoDestroy: !0,
    bind: "load",
    threshold: 500,
    visibleOnly: !1,
    appendScroll: t,
    scrollDirection: "both",
    imageBase: null,
    defaultImage: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
    placeholder: null,
    delay: -1,
    combined: !1,
    attribute: "data-src",
    srcsetAttribute: "data-srcset",
    sizesAttribute: "data-sizes",
    retinaAttribute: "data-retina",
    loaderAttribute: "data-loader",
    imageBaseAttribute: "data-imagebase",
    removeAttribute: !0,
    handledName: "handled",
    loadedName: "loaded",
    effect: "show",
    effectTime: 0,
    enableThrottle: !0,
    throttle: 250,
    beforeLoad: e,
    afterLoad: e,
    onError: e,
    onFinishedAll: e
  }, n(t).on("load", function () {
    o = !0;
  });
}(window); // OBJECTFIT BACKGROUND IMAGE

function objectFitPolyfill() {
  jQuery('div.objectfit').each(function () {
    var $container = jQuery(this),
        imgUrl = $container.find('img').attr('data-original-src');

    if (imgUrl) {
      $container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
    }
  });
} // SITEWIDE - OBJECTFIT BACKGROUND IMAGE


jQuery(document).ready(function ($) {
  if (!Modernizr.objectfit) {
    objectFitPolyfill();
  }
});
jQuery(window).resize(function () {
  // RESPONSIVE JQUERY
  if (window.matchMedia("(max-width: 1240px)").matches) {
    jQuery('body').addClass('mobile');
    console.log("Less than 1240px");
  } else {
    jQuery('body').removeClass('mobile');
  }
}).resize(); // Validate & submit process

(function ($) {})(jQuery);

$ = jQuery.noConflict();
var doc = document.documentElement;
doc.setAttribute('data-useragent', navigator.userAgent); // FLIPSTER

/*! jQuery.Flipster, v1.1.2 (built 2017-11-10) */

!function (a, b, c) {
  "use strict";

  function d(a, b) {
    var c = null;
    return function () {
      var d = this,
          e = arguments;
      null === c && (c = setTimeout(function () {
        a.apply(d, e), c = null;
      }, b));
    };
  }

  var e = function () {
    var a = {};
    return function (b) {
      if (a[b] !== c) return a[b];
      var d = document.createElement("div"),
          e = d.style,
          f = b.charAt(0).toUpperCase() + b.slice(1),
          g = ["webkit", "moz", "ms", "o"],
          h = (b + " " + g.join(f + " ") + f).split(" ");

      for (var i in h) {
        if (h[i] in e) return a[b] = h[i];
      }

      return a[b] = !1;
    };
  }(),
      f = "http://www.w3.org/2000/svg",
      g = function () {
    var a;
    return function () {
      if (a !== c) return a;
      var b = document.createElement("div");
      return b.innerHTML = "<svg/>", a = b.firstChild && b.firstChild.namespaceURI === f;
    };
  }(),
      h = a(b),
      i = e("transform"),
      j = {
    itemContainer: "ul",
    itemSelector: "li",
    start: "center",
    fadeIn: 400,
    loop: !1,
    autoplay: !1,
    pauseOnHover: !0,
    style: "coverflow",
    spacing: -.6,
    click: !0,
    keyboard: !0,
    scrollwheel: !0,
    touch: !0,
    nav: !1,
    buttons: !1,
    buttonPrev: "Previous",
    buttonNext: "Next",
    onItemSwitch: !1
  },
      k = {
    main: "flipster",
    active: "flipster--active",
    container: "flipster__container",
    nav: "flipster__nav",
    navChild: "flipster__nav__child",
    navItem: "flipster__nav__item",
    navLink: "flipster__nav__link",
    navCurrent: "flipster__nav__item--current",
    navCategory: "flipster__nav__item--category",
    navCategoryLink: "flipster__nav__link--category",
    button: "flipster__button",
    buttonPrev: "flipster__button--prev",
    buttonNext: "flipster__button--next",
    item: "flipster__item",
    itemCurrent: "flipster__item--current",
    itemPast: "flipster__item--past",
    itemFuture: "flipster__item--future",
    itemContent: "flipster__item__content"
  },
      l = new RegExp("\\b(" + k.itemCurrent + "|" + k.itemPast + "|" + k.itemFuture + ")(.*?)(\\s|$)", "g"),
      m = new RegExp("\\s\\s+", "g");

  a.fn.flipster = function (b) {
    if ("string" == typeof b) {
      var e = Array.prototype.slice.call(arguments, 1);
      return this.each(function () {
        var c = a(this).data("methods");
        return c[b] ? c[b].apply(this, e) : this;
      });
    }

    var n = a.extend({}, j, b);
    return this.each(function () {
      function b(a) {
        var b = "next" === a ? n.buttonNext : n.buttonPrev;
        return "custom" !== n.buttons && g ? '<svg viewBox="0 0 13 20" xmlns="' + f + '" aria-labelledby="title"><title>' + b + '</title><polyline points="10,3 3,10 10,17"' + ("next" === a ? ' transform="rotate(180 6.5,10)"' : "") + "/></svg>" : b;
      }

      function e(c) {
        return c = c || "next", a('<button class="' + k.button + " " + ("next" === c ? k.buttonNext : k.buttonPrev) + '" role="button" />').html(b(c)).on("click", function (a) {
          v(c), a.preventDefault();
        });
      }

      function j() {
        n.buttons && J.length > 1 && (O.find("." + k.button).remove(), O.append(e("prev"), e("next")));
      }

      function o() {
        var b = {};
        !n.nav || J.length <= 1 || (L && L.remove(), L = a('<ul class="' + k.nav + '" role="navigation" />'), N = a(""), J.each(function (c) {
          var d = a(this),
              e = d.data("flip-category"),
              f = d.data("flip-title") || d.attr("title") || c,
              g = a('<a href="#" class="' + k.navLink + '">' + f + "</a>").data("index", c);

          if (N = N.add(g), e) {
            if (!b[e]) {
              var h = a('<li class="' + k.navItem + " " + k.navCategory + '">'),
                  i = a('<a href="#" class="' + k.navLink + " " + k.navCategoryLink + '" data-flip-category="' + e + '">' + e + "</a>").data("category", e).data("index", c);
              b[e] = a('<ul class="' + k.navChild + '" />'), N = N.add(i), h.append(i, b[e]).appendTo(L);
            }

            b[e].append(g);
          } else L.append(g);

          g.wrap('<li class="' + k.navItem + '">');
        }), L.on("click", "a", function (b) {
          var c = a(this).data("index");
          c >= 0 && (v(c), b.preventDefault());
        }), "after" === n.nav ? O.append(L) : O.prepend(L), M = L.find("." + k.navItem));
      }

      function p() {
        if (n.nav) {
          var b = K.data("flip-category");
          M.removeClass(k.navCurrent), N.filter(function () {
            return a(this).data("index") === Q || b && a(this).data("category") === b;
          }).parent().addClass(k.navCurrent);
        }
      }

      function q() {
        O.css("transition", "none"), G.css("transition", "none"), J.css("transition", "none");
      }

      function r() {
        O.css("transition", ""), G.css("transition", ""), J.css("transition", "");
      }

      function s() {
        var b,
            c = 0;
        return J.each(function () {
          (b = a(this).height()) > c && (c = b);
        }), c;
      }

      function t(b) {
        if (b && q(), H = G.width(), G.height(s()), !H) return void (I = I || setInterval(function () {
          t(b);
        }, 500));
        I && (clearInterval(I), I = !1), J.each(function (c) {
          var d,
              e,
              f = a(this);
          f.attr("class", function (a, b) {
            return b && b.replace(l, "").replace(m, " ");
          }), d = f.outerWidth(), 0 !== n.spacing && f.css("margin-right", d * n.spacing + "px"), e = f.position().left, P[c] = -1 * (e + d / 2 - H / 2), c === J.length - 1 && (u(), b && setTimeout(r, 1));
        });
      }

      function u() {
        var b,
            d,
            e,
            f = J.length;
        J.each(function (c) {
          b = a(this), d = " ", c === Q ? (d += k.itemCurrent, e = f + 1) : c < Q ? (d += k.itemPast + " " + k.itemPast + "-" + (Q - c), e = f - (Q - c)) : (d += k.itemFuture + " " + k.itemFuture + "-" + (c - Q), e = f - (c - Q)), b.css("z-index", e).attr("class", function (a, b) {
            return b && b.replace(l, "").replace(m, " ") + d;
          });
        }), Q >= 0 && (H && P[Q] !== c || t(!0), i ? G.css("transform", "translateX(" + P[Q] + "px)") : G.css({
          left: P[Q] + "px"
        })), p();
      }

      function v(a) {
        var b = Q;
        if (!(J.length <= 1)) return "prev" === a ? Q > 0 ? Q-- : n.loop && (Q = J.length - 1) : "next" === a ? Q < J.length - 1 ? Q++ : n.loop && (Q = 0) : "number" == typeof a ? Q = a : a !== c && (Q = J.index(a), n.loop && b != Q && (b == J.length - 1 && Q != J.length - 2 && (Q = 0), 0 == b && 1 != Q && (Q = J.length - 1))), K = J.eq(Q), Q !== b && n.onItemSwitch && n.onItemSwitch.call(O, J[Q], J[b]), u(), O;
      }

      function w(a) {
        return n.autoplay = a || n.autoplay, clearInterval(R), R = setInterval(function () {
          var a = Q;
          v("next"), a !== Q || n.loop || clearInterval(R);
        }, n.autoplay), O;
      }

      function x() {
        return clearInterval(R), R = 0, O;
      }

      function y(a) {
        return x(), n.autoplay && a && (R = -1), O;
      }

      function z() {
        t(!0), O.hide().css("visibility", "").addClass(k.active).fadeIn(n.fadeIn);
      }

      function A() {
        if (G = O.find(n.itemContainer).addClass(k.container), J = G.find(n.itemSelector), !(J.length <= 1)) return J.addClass(k.item).each(function () {
          var b = a(this);
          b.children("." + k.itemContent).length || b.wrapInner('<div class="' + k.itemContent + '" />');
        }), n.click && J.on("click.flipster touchend.flipster", function (b) {
          S || (a(this).hasClass(k.itemCurrent) || b.preventDefault(), v(this));
        }), j(), o(), Q >= 0 && v(Q), O;
      }

      function B(a) {
        n.keyboard && (a[0].tabIndex = 0, a.on("keydown.flipster", d(function (a) {
          var b = a.which;
          37 !== b && 39 !== b || (v(37 === b ? "prev" : "next"), a.preventDefault());
        }, 250, !0)));
      }

      function C(a) {
        if (n.scrollwheel) {
          var b,
              c,
              e = !1,
              f = 0,
              g = 0,
              i = 0,
              j = /mozilla/.test(navigator.userAgent.toLowerCase()) && !/webkit/.test(navigator.userAgent.toLowerCase());
          a.on("mousewheel.flipster wheel.flipster", function () {
            e = !0;
          }).on("mousewheel.flipster wheel.flipster", d(function (a) {
            clearTimeout(g), g = setTimeout(function () {
              f = 0, i = 0;
            }, 300), a = a.originalEvent, i += a.wheelDelta || -1 * (a.deltaY + a.deltaX), Math.abs(i) < 25 && !j || (f++, b = i > 0 ? "prev" : "next", c !== b && (f = 0), c = b, (f < 6 || f % 3 == 0) && v(b), i = 0);
          }, 50)), h.on("mousewheel.flipster wheel.flipster", function (a) {
            e && (a.preventDefault(), e = !1);
          });
        }
      }

      function D(a) {
        if (n.touch) {
          var b, c, d, e, f, g;
          a.on({
            "touchstart.flipster": function touchstartFlipster(a) {
              a = a.originalEvent, b = a.touches ? a.touches[0].clientX : a.clientX, c = a.touches ? a.touches[0].clientY : a.clientY;
            },
            "touchmove.flipster": function touchmoveFlipster(a) {
              a = a.originalEvent, d = a.touches ? a.touches[0].clientX : a.clientX, e = a.touches ? a.touches[0].clientY : a.clientY, g = d - b, f = e - c, Math.abs(g) > 30 && Math.abs(f) < 100 && a.preventDefault();
            },
            "touchend.flipster touchcancel.flipster ": function touchendFlipsterTouchcancelFlipster() {
              g = d - b, f = e - c, Math.abs(g) > 30 && Math.abs(f) < 100 && v(g > 0 ? "prev" : "next");
            }
          });
        }
      }

      function E() {
        var a;
        if (O.css("visibility", "hidden"), A(), J.length <= 1) return void O.css("visibility", "");
        a = !!n.style && "flipster--" + n.style.split(" ").join(" flipster--"), O.addClass([k.main, i ? "flipster--transform" : " flipster--no-transform", a, n.click ? "flipster--click" : ""].join(" ")), n.start && (Q = "center" === n.start ? Math.floor(J.length / 2) : n.start), v(Q);
        var b = O.find("img");

        if (b.length) {
          var c = 0;
          b.on("load", function () {
            ++c >= b.length && z();
          }), setTimeout(z, 750);
        } else z();

        h.on("resize.flipster", d(t, 400)), n.autoplay && w(), n.pauseOnHover && G.on("mouseenter.flipster", function () {
          R ? y(!0) : x();
        }).on("mouseleave.flipster", function () {
          -1 === R && w();
        }), B(O), C(G), D(G);
      }

      var F,
          G,
          H,
          I,
          J,
          K,
          L,
          M,
          N,
          O = a(this),
          P = [],
          Q = 0,
          R = !1,
          S = !1;
      F = {
        jump: v,
        next: function next() {
          return v("next");
        },
        prev: function prev() {
          return v("prev");
        },
        play: w,
        stop: x,
        pause: y,
        index: A
      }, O.data("methods", F), O.hasClass(k.active) || E();
    });
  };
}(jQuery, window);

if ($('.page-template-template-training').length) {} else {
  // isOnScreen.min.js - https://github.com/moagrius/isOnScreen
  !function (a) {
    a.fn.isOnScreen = function (b) {
      var c = this.outerHeight(),
          d = this.outerWidth();
      if (!d || !c) return !1;
      var e = a(window),
          f = {
        top: e.scrollTop(),
        left: e.scrollLeft()
      };
      f.right = f.left + e.width(), f.bottom = f.top + e.height();
      var g = this.offset();
      g.right = g.left + d, g.bottom = g.top + c;
      var h = {
        top: f.bottom - g.top,
        left: f.right - g.left,
        bottom: g.bottom - f.top,
        right: g.right - f.left
      };
      return "function" == typeof b ? b.call(this, h) : h.top > 0 && h.left > 0 && h.right > 0 && h.bottom > 0;
    };
  }(jQuery);
}